import DashboardLayout from "@/layout/dashboard/DashboardLayout.vue";
// GeneralViews
import NotFound from "@/pages/NotFoundPage.vue";

// Admin pages
import Dashboard from "@/pages/Dashboard.vue";
import UserProfile from "@/pages/UserProfile.vue";
import News from "@/pages/News.vue";
import Partner from "@/pages/Partner.vue";
import Services from "@/pages/Services.vue";
import Notifications from "@/pages/Notifications.vue";
import Icons from "@/pages/Icons.vue";
import Maps from "@/pages/Maps.vue";
import Payements from "@/pages/Payements.vue";
import Typography from "@/pages/Typography.vue";
import Reservations from "@/pages/Reservations.vue";
import AddCategory from "@/pages/AddCategory.vue";
import Category from "@/pages/Category.vue";

const routes = [
  {
    path: "/",
    component: DashboardLayout,
    redirect: "/dashboard",
    children: [
      {
        path: "dashboard",
        name: "Tableau de bord",
        component: Dashboard,
      },
      {
        path: "setting",
        name: "Paramètres",
        component: UserProfile,
      },

      {
        path: "news",
        name: "News",
        component: News,
      },
      {
        path: "partners",
        name: "Partenaires",
        component: Partner,
      },
      {
        path: "services",
        name: "Services",
        component: Services,
      },

      {
        path: "notifications",
        name: "Notifications",
        component: Notifications,
      },
      {
        path: "icons",
        name: "icons",
        component: Icons,
      },
      {
        path: "maps",
        name: "maps",
        component: Maps,
      },
      {
        path: "payment/:site/:id",
        name: "Payements",
        component: Payements,
      },
      {
        path: "typography",
        name: "typography",
        component: Typography,
      },
      {
        path: "booking",
        name: "Reservations",
        component: Reservations,
      },
      {
        path: "add-category",
        name: "Ajouter une categorie",
        component: AddCategory,
      },
      {
        path: "category/:category",
        name: "Categories",
        component: Category,
      },
    ],
  },
  { path: "*", component: NotFound },
];

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes;
